module.exports = __webpack_public_path__ + "img/HQ_Strength-Wear-Photos52_18-01-15.e472e3e0.png";